<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules" :labelWidth="labelWidth" :formGroups="formGroups" :viewMode="viewMode">
    </MyForm>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <CancelBtn :mode="mode" @onCancel="cancel"></CancelBtn>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import staffDetailMixin from "../mixin/detail";

export default {
  name: "EscortDetail",
  mixins: [detailMixin, staffDetailMixin],
  data() {
    return {
      baseUrl: 'escort',
      breadcrumb: [
        { name: "人员管理", path: "/staff/escort" },
        { name: "押运员管理", path: "/staff/escort" },
        { name: "添加押运员" },
      ],
      form: {
        name: undefined,
        sex: '男',
        birthday: undefined,
        tel: undefined,
        nation: undefined,
        province: undefined,
        address: undefined,
        contact: undefined,
        contacttel: undefined,
        identitycard: undefined,
      },
      rules: {
        name: [
          { required: true, message: "请填写姓名", trigger: "blur" },
        ],
        birthday: [
          { required: true, message: "请选择出生年月", trigger: "blur" },
        ],
        tel: [
          { required: true, validator: this.checkPhone, trigger: "blur" },
        ],
        // nation: [
        //   { required: true, message: "请填写民族", trigger: "blur" },
        // ],
        // province: [
        //   { required: true, message: "请填写籍贯", trigger: "blur" },
        // ],
        address: [
          { required: true, message: "请填写住址", trigger: "blur" },
        ],
        // contact: [
        //   { required: true, message: "请填写紧急联系人姓名", trigger: "blur" },
        // ],
        // contacttel: [
        //   { required: true, validator: this.checkPhone, trigger: "blur" },
        // ],
      },
    };
  },
  methods: {
    setOptions({ iswork, edu, team, maxescort }) {
      this.formGroups[0].formCtrl.map(c => {
        if (c.keyName == 'nation' && this.NATION) {
          // console.log({...c})
          c.options = this.NATION.map(v => {
            return {
              label: v.name,
              value: v.name,
            }
          })
          // 没有姓名说明是新建信息
          if (!this.form.name) this.form.nation = this.NATION[0].name
          // console.log([...c.options])
          // console.log({...this.form})
        } else if (c.keyName == 'iswork' && iswork) {
          for (const key in iswork) {
            if (Object.hasOwnProperty.call(iswork, key)) {
              const val = iswork[key];
              c.options.push({
                label: val,
                value: key + '',
              })
            }
          }
          this.form.iswork = '1'
          console.log([...c.options])
          console.log({ ...this.form })
        }
        if (c.keyName == 'edu' && edu.length) {
          c.options = edu.map(v => {
            return {
              label: v.eduname,
              value: v.eduname,
            }
          })
          this.form.edu = edu[0].eduname
        }
        if (c.keyName == 'fleet' && team.length) {
          c.options = team.map(v => {
            return {
              label: v.nickname + '车队',
              value: v.id,
            }
          })
          this.form.fleet = team[0].id
        }
        if (maxescort && !this.form.maxescort) {
          this.form.maxescort = maxescort
        }
      })
    },
  },
  created() {
    // this.formGroups[0].formCtrl.unshift({
    //   label: "车队",
    //   keyName: "fleet",
    //   err: "请选择车队",
    //   type: "select",
    //   options: [],
    // })
    // this.formGroups[0].formCtrl.splice(12, 0, {
    //   label: "基本工资（元）",
    //   keyName: "maxescort",
    //   err: "请填写基本工资",
    //   type: "number",
    // })
    this.formGroups[0].formCtrl.push({
      label: "押运员从业资格证",
      keyName: "escortcard",
      type: "file",
      ptype: "person",
      tips: "最多上传2张图片",
      max: 2,
      className: "block",
    })
    this.formGroups.length = 1
    this.getOptions();
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
